import { IOption } from 'types/common';
import { SetToastFunc, ToastSeverity } from 'types/toast';

export const onSubmitForm =
	<T>(
		submit: (body: T) => Promise<T | undefined>,
		addToast?: SetToastFunc,
		saveText?: string,
		failText?: string
	): ((values: T, submitProps?: any) => Promise<T | undefined>) =>
	async (values: T, submitProps?: any) => {
		const newValues: T = {
			...values
		};

		try {
			const returnValue = await submit(newValues);
			if (addToast) {
				addToast({
					severity: ToastSeverity.Success,
					content: intl.tr(saveText || 'save.changes.dialog.approve'),
					id: 'submit-form-success'
				});
			}
			submitProps?.resetForm({ values });
			return returnValue;
		} catch (error) {
			if (addToast) {
				addToast({
					severity: ToastSeverity.Error,
					content: intl.tr(failText || 'save.changes.dialog.failed'),
					error
				});
			}
			return undefined;
		}
	};

export const resetFormikField = async (formik: any, fieldName: string) => {
	await formik.setFieldValue(fieldName, formik.initialValues[fieldName]);
	await formik.setFieldTouched(fieldName, false);
	await formik.setFieldError(fieldName, undefined);
};

export const isOptionEqualToValue = (
	option: IOption,
	value: string | IOption
) => option.value === ((value as IOption).value || value);
